module.exports = __webpack_public_path__ + "static/media/YF52_4.7d019935.jpg";